import React from 'react'
import Template from '../components/Template'
import signupImg from '../assets/img1 (1).jpeg'

function Signup({setIsLoggedIn}) {
  return (
   
    <Template
      title="Join the millions learning to code with DEV-G for free"
      desc1="Build skills for today, tomorrow, and beyond."
      desc2="Education to future-proof your career."
      image={signupImg}
      formtype="signup"
      setIsLoggedIn={setIsLoggedIn}
    />
  
  )
}

export default Signup